<template>
  <div class="gallery-view-grid">
    <ServicedGalleryThumbnail
      :size="0"
      v-for="(thumb, index) in previewThumbs"
      :key="thumb.id"
      :image="thumb.uploaded_file.thumb.url"
      @click="openImage(index)"
      :medium="thumb"
    />
    <PostGalleryShowMore
      :total-elements="post.event_media_count"
      :post="post"
      :size="0"
    />
  </div>
</template>

<script lang="ts">
import {
  computed,
  ComputedRef,
  defineComponent,
  inject,
  PropType,
  toRef,
} from "vue"
import { Post } from "suus-api"
import { GalleryMedium } from "features/gallery/gallery.types"
import PostGalleryShowMore from "features/posts/gallery/PostGalleryShowMore.vue"
import ServicedGalleryThumbnail from "features/gallery/service/ServicedGalleryThumbnail.vue"
import { PostLightboxService } from "features/posts/gallery/lightbox/post-lightbox.service"

export default defineComponent({
  name: "PostGalleryPreviewMobile",
  components: {
    ServicedGalleryThumbnail,
    PostGalleryShowMore,
  },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    canEditHighlights: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const postRef = toRef(props, "post")
    const previewThumbs: ComputedRef<GalleryMedium[]> = computed(
      () => postRef.value.event_media_preview
    )

    const postLightboxService: PostLightboxService = inject(
      "PostLightboxService"
    )

    const openImage = (index: number) => {
      postLightboxService.openLightbox(index)
    }

    return {
      previewThumbs,
      openImage,
    }
  },
})
</script>

<style scoped>
.gallery-view-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: minmax(min-content, max-content);
  justify-content: center;
  grid-gap: 4px;
}
</style>
